var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:office-building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.3335 1.5V10.5H7.3335V8.75H8.66683V10.5H12.6668V1.5H3.3335ZM4.66683 2.5H6.00016V3.5H4.66683V2.5ZM7.3335 2.5H8.66683V3.5H7.3335V2.5ZM10.0002 2.5H11.3335V3.5H10.0002V2.5ZM4.66683 4.5H6.00016V5.5H4.66683V4.5ZM7.3335 4.5H8.66683V5.5H7.3335V4.5ZM10.0002 4.5H11.3335V5.5H10.0002V4.5ZM4.66683 6.5H6.00016V7.5H4.66683V6.5ZM7.3335 6.5H8.66683V7.5H7.3335V6.5ZM10.0002 6.5H11.3335V7.5H10.0002V6.5ZM4.66683 8.5H6.00016V9.5H4.66683V8.5ZM10.0002 8.5H11.3335V9.5H10.0002V8.5Z",
    fill: "#A7A7A7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e9b5378819105428f61d16f693a2f139.svg";
export { ForwardRef as ReactComponent };